import type {
  DayWidgetWeekEntry,
  WeekWidgetWeekEntry,
  WidgetWeekEntry,
} from "@/lib/schema";
import { bodyMeasurementLog } from "./body-measurement-log";
import { bodyMeasurementTrend } from "./body-measurement-trend";
import { counter } from "./counter";
import { mealDiary } from "./meal-diary";
import { mealLog } from "./meal-log";
import { mealLogSummary } from "./meal-log-summary";
import { painLog } from "./pain-log";
import { painTrend } from "./pain-trend";
import { recurringTasks } from "./recurring-tasks";
import { sleepLog } from "./sleep-log";
import { todoList } from "./todo-list";
import type { WidgetModule } from "./types";
import { weeklyPointSummary } from "./weekly-point-summary";
import { workdayLog } from "./workday-log";
import { workoutLog } from "./workout-log";

// biome-ignore lint/suspicious/noExplicitAny: registry holds heterogeneous widget modules.
export type AnyWidgetModule = WidgetModule<any>;

export const WIDGET_REGISTRY: Record<string, AnyWidgetModule> = {
  "body-measurement-log": bodyMeasurementLog,
  "body-measurement-trend": bodyMeasurementTrend,
  counter,
  "meal-diary": mealDiary,
  "meal-log": mealLog,
  "meal-log-summary": mealLogSummary,
  "pain-log": painLog,
  "pain-trend": painTrend,
  "recurring-tasks": recurringTasks,
  "sleep-log": sleepLog,
  "todo-list": todoList,
  "weekly-point-summary": weeklyPointSummary,
  "workday-log": workdayLog,
  "workout-log": workoutLog,
};

export function getWidgetModule(kind: string): AnyWidgetModule | null {
  return WIDGET_REGISTRY[kind] ?? null;
}

export function listWidgetKinds(scope?: "day" | "week"): Array<{
  kind: string;
  label: string;
  scope: "day" | "week";
}> {
  return Object.values(WIDGET_REGISTRY)
    .filter((m) => (scope ? m.scope === scope : true))
    .map((m) => ({ kind: m.kind, label: m.label, scope: m.scope }));
}

export function isDayWidgetEntry(e: WidgetWeekEntry): e is DayWidgetWeekEntry {
  return getWidgetModule(e.config.kind)?.scope === "day";
}

export function isWeekWidgetEntry(
  e: WidgetWeekEntry,
): e is WeekWidgetWeekEntry {
  return getWidgetModule(e.config.kind)?.scope === "week";
}
